module.exports = "<svg width=\"6\" height=\"7\" viewBox=\"40 0 6 7\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" d=\"M40 7V0l6 3.5z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/fill/triangle.svg
// module id = 539
// module chunks = 0